import React, { useEffect } from 'react';
import history from 'lib/history';
import { observer } from 'mobx-react';
import userStore from 'store/user';
import configStore from 'store/config';
import accountStore from 'store/account-manage';
import { EAuthority, EFirstStatus } from 'interfaces/account-manage';
import Welcome from 'components/welcome/welcome';
import Main from './main';
import { Switch } from 'react-router-dom';
import PrivateRoute from 'components/public-components/private-route';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import FirstUpdatePassword from 'components/welcome/first-update-password';
import { useParams } from 'react-router-dom';
import accountManage from 'store/account-manage';

const MainComponent = observer(() => {
  const params = useParams<{ merchantId?: string }>();

  const authenticate = async () => {
    try {
      const {
        data: { data },
      } = await userStore.getProfile();
      const {
        data: {
          data: { language, minSpend },
        },
      } = await configStore.getWebConfig();
      await accountStore.getOutlets();
      configStore.minSpend = minSpend;
      accountManage.changeLang(language);
      userStore.setUserProfile(data);
      userStore.setMerchantId(params.merchantId ?? null);
      userStore.updateLoadingStatus(false);
      if (userStore.isFirstLogin || data.isFirstLogin) {
        try {
          const { firstStatus } = await accountStore.getCurrentUser();
          switch (firstStatus) {
            case EFirstStatus.NONE:
              history.push('/main/dashboard');
              break;
            case EFirstStatus.PASSWORD:
              history.push('/main/update-password');
              break;
            default:
              history.replace('/main/welcome');
          }
        } catch (e) {}
      } else {
        getCurrentUserInfo();
      }
    } catch (e) {
      authFailed(e);
    }
  };

  const getCurrentUserInfo = async () => {
    await accountStore.getCurrentUser();
    if (!location.pathname.includes('dashboard')) {
      return;
    }
    const auths = accountStore.authorities;
    if (auths.includes(EAuthority.ViewDashboard)) {
      history.push('/main/dashboard');
    } else if (auths.includes(EAuthority.ViewTransactions)) {
      history.push('/main/transactions');
    } else if (auths.includes(EAuthority.ViewPayment)) {
      history.push('/main/payments/payout');
    } else if (auths.includes(EAuthority.ViewUserManagement)) {
      history.push('/main/accountManage/role');
    } else if (auths.includes(EAuthority.ViewHelp)) {
      history.push('/main/help');
    } else if (auths.includes(EAuthority.ViewProfile)) {
      history.push('/main/profile');
    }
  };

  const authFailed = (e: any) => {
    history.push('/login');
  };

  useEffect(() => {
    authenticate();
  }, []);
  const antIcon = <LoadingOutlined style={{ fontSize: 30 }} />;

  return !userStore.loading ? (
    <>
      <Switch>
        <PrivateRoute
          exact
          path="/main/welcome"
          component={Welcome}
          redirectTo="/login"
          isAuthenticated={userStore.isFirstLogin || userStore.userProfile.isFirstLogin}
        />
        <PrivateRoute
          exact
          path="/main/update-password"
          component={FirstUpdatePassword}
          redirectTo="/login"
          isAuthenticated={userStore.isFirstLogin || userStore.userProfile.isFirstLogin}
        />
        <PrivateRoute
          exact
          path="/*"
          component={Main}
          redirectTo="/main"
          isAuthenticated={!userStore.userProfile.isFirstLogin}
        />
      </Switch>
    </>
  ) : (
    <Spin
      tip="Loading, please wait..."
      indicator={antIcon}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 100,
      }}
    />
  );
});

export default MainComponent;
